var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { CustomElement, P, Watch, PropertyConverters, Utils, PacemEventTarget } from '@pacem/pacem-core';
//namespace Pacem.Components.Plus {
let PacemRouterHashStateElement = class PacemRouterHashStateElement extends PacemEventTarget {
    constructor() {
        super(...arguments);
        this.default = {};
        this.state = {};
        this.normalizedState = {};
        this._routerNavigatingHandler = (_) => {
            this.#locked = true;
        };
        this._routerNavigateHandler = (_) => {
            this.#locked = false;
            this._updateStateFromURI();
        };
    }
    #locked;
    viewActivatedCallback() {
        super.viewActivatedCallback();
        this._updateStateFromURI();
        this._setupRouterHandlers(this.router);
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        switch (name) {
            case 'state':
                if (!first && !this.#locked) {
                    this._updateNormalizedState();
                    this._updateURIFromState();
                }
                break;
            case 'disabled':
                if (!!val) {
                    this._updateStateFromURI();
                }
                break;
            case 'default':
                this._updateStateFromURI();
                break;
            case 'router':
                if (!first) {
                    this._disposeRouterHandlers(old);
                    this._setupRouterHandlers(val);
                }
                break;
        }
    }
    disconnectedCallback() {
        this._disposeRouterHandlers();
        super.disconnectedCallback();
    }
    _setupRouterHandlers(router = this.router) {
        if (!Utils.isNull(router)) {
            window.addEventListener('navigating', this._routerNavigatingHandler, false);
            window.addEventListener('navigate', this._routerNavigateHandler, false);
        }
    }
    _disposeRouterHandlers(router = this.router) {
        if (!Utils.isNull(router)) {
            window.removeEventListener('navigating', this._routerNavigatingHandler, false);
            window.removeEventListener('navigate', this._routerNavigateHandler, false);
        }
    }
    _currentBasePath() {
        const router = this.router;
        if (!Utils.isNull(router)) {
            const q = router.state.$querystring;
            return this._normalizePath(document.location.pathname, q);
        }
        return null;
    }
    _normalizePath(path, q) {
        if (Utils.isNullOrEmpty(path)) {
            return path;
        }
        if (path.endsWith('/')) {
            path = path.substring(0, path.length - 1);
        }
        q ??= '';
        return path + (q.length > 0 ? ('?' + q) : '');
    }
    _areStatesEquivalent(s1, s2) {
        const state1 = Utils.extend({}, s1 || {}), state2 = Utils.extend({}, s2 || {});
        for (let prop in state1) {
            if (!this._areSubstantiallyEquivalent(state1[prop], state2[prop])) {
                return false;
            }
            delete state1[prop];
            delete state2[prop];
        }
        for (let prop in state2) {
            if (!this._areSubstantiallyEquivalent(state1[prop], state2[prop])) {
                return false;
            }
        }
        return true;
    }
    _updateNormalizedState(state = this.state) {
        if (this.disabled || this.#locked) {
            return;
        }
        const normalizedState = this._normalizeState(state);
        if (!this._areStatesEquivalent(normalizedState, this.normalizedState)) {
            this.normalizedState = normalizedState;
        }
    }
    _updateStateFromURI() {
        if (this.disabled || this.#locked) {
            return;
        }
        var state = Utils.extend({}, this.default || {});
        const router = this.router;
        if (!Utils.isNull(router)) {
            const denormalized = this._denormalizeState(Utils.URIs.parseQuery(router.state && router.state.$hash || '{}'));
            Utils.extend(state, denormalized);
        }
        if (!this._areStatesEquivalent(this.state, state)) {
            this.state = state;
        }
    }
    _updateURIFromState(state = this.normalizedState) {
        if (this.disabled || this.#locked) {
            return;
        }
        const router = this.router;
        if (!Utils.isNull(router)) {
            const actual = this._currentBasePath();
            const currentState = Utils.URIs.parseQuery(router.state.$hash || '{}'), targetState = state || {};
            if (!this._areStatesEquivalent(currentState, targetState)) {
                // checked state equivalence to avoid superfluous navigation
                const clean = this._cleanupStateForURI(targetState);
                var url = actual;
                if (!Utils.isNullOrEmpty(clean)) {
                    url = Utils.URIs.appendQuery(actual, clean, false, true);
                }
                // navigate
                router.path = url;
            }
        }
    }
    _areSubstantiallyEquivalent(v1, v2) {
        v1 ??= '';
        v2 ??= '';
        return v1.toString() == v2.toString() || Utils.areSemanticallyEqual(v1, v2) || JSON.stringify(v1) === JSON.stringify(v2);
    }
    _cleanupStateForURI(state = this.state) {
        const copy = Utils.clone(state || {}), base = this.default;
        for (let key in copy) {
            if ((Utils.isNullOrEmpty(copy[key]) && (Utils.isNull(base) || !(key in base)))
                || (!Utils.isNull(base) && (key in base) && this._areSubstantiallyEquivalent(base[key], copy[key]))) {
                delete copy[key];
            }
        }
        return copy;
    }
    _normalizeState(state = this.state, mold = this.default) {
        var output = {};
        const base = mold;
        for (let key in state || {}) {
            const value = state[key];
            if (Utils.isNullOrEmpty(value)) {
                if (!Utils.isNull(base) && (key in base) && !Utils.isNullOrEmpty(base[key])) {
                    output[key] = '';
                }
                continue;
            }
            switch (typeof value) {
                case 'number':
                case 'bigint':
                case 'boolean':
                    Object.defineProperty(output, key, { enumerable: true, value: value.toString() });
                    break;
                case 'symbol':
                case 'string':
                    Object.defineProperty(output, key, { enumerable: true, value });
                    break;
                default:
                    if (Utils.Dates.isDate(value)) {
                        Object.defineProperty(output, key, { enumerable: true, value: value.toISOString() });
                    }
                    else if (value instanceof RegExp) {
                        Object.defineProperty(output, key, { enumerable: true, value: value.source });
                    }
                    else {
                        throw new Error('Type not supported to be normalized into a URI hash.');
                    }
                    break;
            }
        }
        return output;
    }
    _denormalizeState(state = this.normalizedState, mold = this.default) {
        const output = {};
        const base = mold || {};
        for (let prop in state) {
            if (!(prop in base)) {
                output[prop] = state[prop];
                continue;
            }
            const moldProp = base[prop], value = state[prop];
            switch (typeof moldProp) {
                case 'boolean':
                    Object.defineProperty(output, prop, { enumerable: true, value: PropertyConverters.Boolean.convert(value) });
                    break;
                case 'number':
                case 'bigint':
                    Object.defineProperty(output, prop, { enumerable: true, value: PropertyConverters.Number.convert(value) });
                    break;
                case 'symbol':
                case 'string':
                    Object.defineProperty(output, prop, { enumerable: true, value: PropertyConverters.String.convert(value) });
                    break;
                default:
                    if (moldProp instanceof Date) {
                        Object.defineProperty(output, prop, { enumerable: true, value: PropertyConverters.Date.convert(value) });
                    }
                    else if (moldProp instanceof RegExp) {
                        Object.defineProperty(output, prop, { enumerable: true, value: new RegExp(value, moldProp.flags) });
                    }
                    else {
                        Object.defineProperty(output, prop, { enumerable: true, value });
                    }
                    break;
            }
        }
        return output;
    }
    set(key, value) {
        var obj = {};
        if (typeof key === 'string') {
            Object.defineProperty(obj, key, { enumerable: true, value });
        }
        else {
            obj = key;
        }
        this.state = Utils.extend({}, this.state || {}, obj);
    }
};
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Element })
], PacemRouterHashStateElement.prototype, "router", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Json })
], PacemRouterHashStateElement.prototype, "default", void 0);
__decorate([
    Watch()
], PacemRouterHashStateElement.prototype, "state", void 0);
__decorate([
    Watch()
], PacemRouterHashStateElement.prototype, "normalizedState", void 0);
PacemRouterHashStateElement = __decorate([
    CustomElement({ tagName: P + '-router-hash-state' })
], PacemRouterHashStateElement);
export { PacemRouterHashStateElement };
